// extracted by mini-css-extract-plugin
export default {"popperWrap":"NewGuid_popperWrap__hKWjq","closeSvg":"NewGuid_closeSvg__lKvOW"};